import { CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME } from '@constants'
import { ObjectDataRecord, ObjectFieldDTO } from '@types'

export const areRowSelectionsEqual = (
  selected: ObjectDataRecord[],
  all: ObjectDataRecord[],
  pkField?: ObjectFieldDTO
) => {
  if (selected.length !== all.length) {
    return false
  }

  if (!selected.length) {
    return true
  }

  if (pkField) {
    const allIds = new Set(all.map(item => item[pkField.name]))

    return selected.every(item => allIds.has(item[pkField.name]))
  }

  const selectedIds = new Set(
    selected.map(
      row => row._id ?? row[CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME]
    )
  )

  return all.every(
    row =>
      selectedIds.has(row._id) ||
      selectedIds.has(row[CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME])
  )
}
